module.exports = __webpack_public_path__ + "media/images/icons/my_questions-598037e22f77e7310aba9869e7f74524.svg";